import React, { useState, useEffect, Fragment } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { getCategory } from "../../actions/admin/category";

const Detail = ({ getCategory, id }) => {
    const [categoryData, setCategoryData] = useState({
        name: "",
        group: ""
    });

    const { name, group } = categoryData;

    useEffect(() => {
        const fetchCategoryData = async () => {
            const category = await getCategory(id);

            setCategoryData({
                name: category.name,
                group: category.group
            });
        };

        fetchCategoryData();
    }, [id, getCategory]);

    return (
        <Fragment>
            <div className="row form-group">
                <div className="col-md-3">Name:</div>
                <div className="col-md-9">{name}</div>
            </div>
            <div className="row form-group">
                <div className="col-md-3">Group:</div>
                <div className="col-md-9">{group}</div>
            </div>
        </Fragment>
    );
};

Detail.propTypes = {
    getCategory: PropTypes.func.isRequired
};

export default connect(null, { getCategory })(Detail);
